module.exports = __webpack_public_path__ + "img/制御工学6_6.d33067f1.png";